// Pinned feeds form the Stage when no screen is shared. They lay out as a grid
// sharing one dynamic aspect ratio (within 4:3..16:9), with no minimum width
// and no overflow (the pinned set is small and explicit).

import { DEFAULT_GAP, Size } from './types';
import { FeedGridPlan, planContentSize, planFeedGrid } from './feed-grid';

export interface PinnedStageProbe {
    /** Aspect ratio of the pinned grid's bounding box (drives orientation). */
    aspect: number;
    plan: FeedGridPlan;
}

export const computePinnedStageProbe = (
    maxBox: Size,
    pinnedCount: number,
    gap = DEFAULT_GAP,
): PinnedStageProbe => {
    const plan = planFeedGrid(maxBox, pinnedCount, { minWidth: 0, gap });
    const content = planContentSize(plan, gap);
    const aspect = content.height > 0 ? content.width / content.height : 16 / 9;
    return { aspect, plan };
};
